import { Routes, Route } from "react-router-dom";
import PaymentTerms from "./PaymentTerms";
import PaymentTermCreateEdit from "./PaymentTermCreateEdit";

const index = () => {
	return (
		<Routes>
			<Route index element={<PaymentTerms />} />
			<Route path='/create' element={<PaymentTermCreateEdit />} />
			<Route path='/:id/edit' element={<PaymentTermCreateEdit />} />
		</Routes>
	);
};

export default index;
